import router from './router'
import store from './store'
import { menusToRoutes, routesToMenuItems, resetTokenAndClearUser } from './utils'
import { LoadingBar } from 'view-design'
import axios from 'axios'

// 是否有菜单数据
let hasMenus = false
router.beforeEach(async (to, from, next) => {
    LoadingBar.start()
    if (localStorage.getItem('token')) {
        if (to.path === '/login') {
            next({path: '/'})
        } else {
            if (hasMenus) {
                localStorage.setItem("last_path", to.path)
                next()
            } else {
                try {
                    // 这里可以用 await 配合请求后台数据来生成路由
                    let data = await axios.post(store.state.urlPort + "/load_menu_items")
                    let routes = ""
                    //data = data["data"]
                    if (data["status"] == 0) {
                        routes = menusToRoutes(data["data"])
                        store.state.menuItems = data["data_menu_items"]
                    }
                    else {
                        console.log("后端返回error:" + data)
                    }
                    // const routes = menusToRoutes(store.state.menuItems)
                    // 动态添加路由
                    router.addRoutes(routes)
                    hasMenus = true
                    var last_path = localStorage.getItem("last_path")
                    if (last_path == null) {
                        next({path: to.path || '/home'})
                        return null
                    }
                    var temp_path = null
                    for (var i = 0; i < routes[0]["children"].length; i++) {
                        temp_path = routes[0]["children"][i]["path"]
                        if ("/" + temp_path == last_path) {
                            next({path: last_path || '/home'})
                            return null
                        }
                    }
                    next({path: to.path || '/home'})
                } catch (error) {
                    resetTokenAndClearUser()
                    next(`/login?redirect=${to.path}`)
                }
            }
        }
    } else {
        hasMenus = false
        if (to.path === '/login') {
            next()
        } else {
            next(`/login?redirect=${to.path}`)
        }
    }
})

router.afterEach(() => {
    LoadingBar.finish()
})